import { ChatMessage } from "../entities/getMessages";
import { ChatSocketRepository } from "../repositories/ChatSocketRepository";

export class OnTempMessageSeen {
	constructor(private repository: ChatSocketRepository) {}

	execute(callback: (data: ChatMessage) => void): void {
		return this.repository.onTempMessageSeen(callback);
	}
}
